import React, { useContext, useEffect, useReducer, useState } from "react";
import { setExternalSignIn, setGoHome } from "../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { sendAnalytics } from "../../../action/homeAction";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { setShowCustomPopup } from "../../../action/action";
import { MyContext } from ".";







const LoaderPage = (props) => {

    const [showLoginTheKnowButton,setShowLoginTheKnowButton]=useState(false);
  
    useEffect(()=>{
        setTimeout(()=>{
            setShowLoginTheKnowButton(true)
        },4000)
    },[])


    return (
        <>
        <div class="loader-body">
           {/* { showLoginTheKnowButton ?
                 <div class="controls">
                         <button class="primary" onClick={props.redirectForLoginIn}>
                            Login to The Know
                         </button>
                </div>
                :

                <div class='loader-main'></div>

            } */}
            <div class='loader-main'></div>
        </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {

    }
}
export default connect(mapStateToProps, { setGoHome, setShowCustomPopup, closeOrderPopUp, sendAnalytics, setExternalSignIn })(
    withTranslation("translations")(LoaderPage)
);